// src/utils/pingCache.ts
const pingCache = new Map();
const inFlightPings = new Map(); // host => Promise

export const shouldPingHost = (host) => {
  const cached = pingCache.get(host);
  const now = Date.now();
  return !cached || now - cached.timestamp > 60000; // 1 minute = 60000 ms
};

export const setPingStatus = (host, status) => {
  pingCache.set(host, {
    timestamp: Date.now(),
    status
  });
  cleanupCache(); 
};

export const getLastPingStatus = (host) => {
  return pingCache.get(host).status || false;
};

const cleanupCache = () => {
  const now = Date.now();
  for (const [host, entry] of pingCache.entries()) {
    if (now - entry.timestamp > 120000) {
      pingCache.delete(host);
    }
  }
};

// Prevent multiple simultaneous pings to same host
export const getOrPingHost = async (host, pingFn) => {
  if (!shouldPingHost(host)) {
    return getLastPingStatus(host);
  }

  if (inFlightPings.has(host)) {
    return inFlightPings.get(host); // return existing promise
  }

  const pingPromise = pingFn(host)
    .then((status) => {
      setPingStatus(host, status);
      inFlightPings.delete(host);
      return status;
    })
    .catch((err) => {
      inFlightPings.delete(host);
      throw err;
    });

  inFlightPings.set(host, pingPromise);
  return pingPromise;
};



// WEBPACK FOOTER //
// ./src/helper/pingCache.js